module.exports = __webpack_public_path__ + "img/khaanpinRed.c340120d.png";